import { TextField, Tooltip } from '@material-ui/core';
import { AutocompleteRenderInputParams } from '@material-ui/lab';
import React, { ReactNode, RefCallback } from 'react';

type renderInputProps = {
  label: string;
  ref: RefCallback<unknown>;
  error: boolean;
  isRequired?: boolean;
  helperText?: string;
  tooltip?: ReactNode;
};

export const renderInput = ({
  label,
  ref,
  error,
  isRequired = false,
  helperText,
  tooltip = null,
}: renderInputProps) => {
  const CreateOrderAutocompleteRenderInput = (params: AutocompleteRenderInputParams) => {
    const inner = (
      <TextField {...params} inputRef={ref} label={label} error={error} helperText={helperText} required={isRequired} />
    );

    if (tooltip) {
      return (
        <Tooltip title={tooltip} arrow={true} placement="top">
          {inner}
        </Tooltip>
      );
    } else {
      return inner;
    }
  };
  return CreateOrderAutocompleteRenderInput;
};
